import { createAction, props } from "@ngrx/store";

import { CountrySelectorData } from "@hermes/api-model-country";
import {
    BannersData,
    FooterData,
    ReinsuranceItem,
    ReinsuranceItemCustomerService,
} from "@hermes/api-model-shell";
import { Locale } from "@hermes/locale";
import { ShellAppearanceType } from "@hermes/utils-generic-constants";

export const updateBasket = createAction(
    "[Basket] Update Basket ",
    props<{ amount: number }>(),
);
export const fetchBanners = createAction("[Shell] Fetch Banners");
export const fetchBannersSuccess = createAction(
    "[Shell] Fetch Banners Success",
    props<{ data: BannersData }>(),
);
export const fetchBannersFailure = createAction(
    "[Shell] Fetch Banners Failure",
    props<{ error: Error }>(),
);

export const fetchFooterItems = createAction("[Shell] Fetch FooterItems");
export const fetchFooterItemsSuccess = createAction(
    "[Shell] Fetch FooterItems Success",
    props<{ data: FooterData }>(),
);
export const fetchFooterItemsFailure = createAction(
    "[Shell] Fetch FooterItems Failure",
    props<{ error: Error }>(),
);

export const fetchSupportInfos = createAction("[Shell] Fetch Support Infos");

export const fetchSupportInfosSuccess = createAction(
    "[Shell] Fetch Support Infos Success",
    props<{
        customerServiceDetail: string;
        footer: Array<ReinsuranceItem | ReinsuranceItemCustomerService>;
    }>(),
);
export const fetchSupportInfosFailure = createAction(
    "[Shell] Fetch Support Infos Failure",
    props<{ error: Error }>(),
);

export const setShell = createAction(
    "[Shell] Set current shell mode",
    props<{
        shell: ShellAppearanceType;
    }>(),
);

export const fetchCountrySelectorData = createAction(
    "[Shell] Fetch Country Selector Data",
);

export const fetchCountrySelectorDataSuccess = createAction(
    "[Shell] Fetch Country Selector Data Success",
    props<{
        countrySelectorData: CountrySelectorData | undefined;
        activatedLocales: Locale[] | undefined;
    }>(),
);

export const fetchCountrySelectorDataError = createAction(
    "[Shell] Fetch Country Selector Data Error",
);
